//#36: País manda. La norma metrológica (país) define la familia del conector.
//USA -> CCS1/NACS ; IEC (Francia/Alemania/Resto/MID) -> CCS2. Se preserva el tier
//(380 A sin refrigerar, 500 A refrigerada).
const CCS2_A_USA = {
  CCS2_380_A: "CCS1_380_A",
  CCS2_500_A_REF: "CCS1_500_A_REF",
}
const USA_A_CCS2 = {
  CCS1_380_A: "CCS2_380_A",
  CCS1_500_A_REF: "CCS2_500_A_REF",
  NACS_380_A: "CCS2_380_A",
  NACS_500_A_REF: "CCS2_500_A_REF",
}

const esCuatro = v => v.EV_NUM_CONECTORES === "420_CUATRO"
const esDuo = v => v.EV_NUM_CONECTORES === "420_DUO"

const convertirConectorPorPais = (v, paisEsUsa, propiedad) => {
  const valor = v[propiedad]
  if (!valor) return
  if (paisEsUsa && valor.includes("CCS2")) {
    v[propiedad] = CCS2_A_USA[valor] || "CCS1_380_A"
  } else if (!paisEsUsa && (valor.includes("CCS1") || valor.includes("NACS"))) {
    v[propiedad] = USA_A_CCS2[valor] || "CCS2_380_A"
  }
}

const aplicarAcoplamientoPais = v => {
  const paisEsUsa = v.EV_VATIMETRO === "USA"
  convertirConectorPorPais(v, paisEsUsa, "EV_TIPO_CONECTOR_RIGHT_FRONT")
  convertirConectorPorPais(v, paisEsUsa, "EV_TIPO_CONECTOR_LEFT_FRONT")
  //#36: DUO/4 (2xCCS1 + 2xNACS) solo existe en USA. Si el país es IEC se degrada a DUO.
  if (!paisEsUsa && esCuatro(v)) {
    v.EV_NUM_CONECTORES = "420_DUO"
  }
}

const limpiarConectoresPorLayout = v => {
  if (v.EV_NUM_CONECTORES === "420_ONE") {
    v.EV_TIPO_CONECTOR_LEFT_FRONT = ""
    v.EV_TIPO_CONECTOR_LEFT_SIDE = ""
    v.EV_TIPO_CONECTOR_RIGHT_SIDE = ""
  }
  if (esDuo(v)) {
    v.EV_TIPO_CONECTOR_LEFT_SIDE = ""
    v.EV_TIPO_CONECTOR_RIGHT_SIDE = ""
  }
}

const aplicarRefrigeracionAire = v => {
  if (v.EV_TIPO_REFRIGERACION !== "AIRE") return
  //Familia de conector frontal por defecto según país.
  const front380 = v.EV_VATIMETRO === "USA" ? "CCS1_380_A" : "CCS2_380_A"
  if (v.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("REF")) {
    v.EV_TIPO_CONECTOR_RIGHT_FRONT = front380
  }
  if ((esDuo(v) || esCuatro(v)) && v.EV_TIPO_CONECTOR_LEFT_FRONT.includes("REF")) {
    v.EV_TIPO_CONECTOR_LEFT_FRONT = front380
  }
  if (esCuatro(v) && v.EV_TIPO_CONECTOR_LEFT_SIDE.includes("REF")) {
    v.EV_TIPO_CONECTOR_LEFT_SIDE = "NACS_380_A"
  }
  if (esCuatro(v) && v.EV_TIPO_CONECTOR_RIGHT_SIDE.includes("REF")) {
    v.EV_TIPO_CONECTOR_RIGHT_SIDE = "NACS_380_A"
  }
}

const aplicarRefrigeracionLiquido = v => {
  if (v.EV_TIPO_REFRIGERACION !== "LIQUIDO") return
  const frontRef = v.EV_VATIMETRO === "USA" ? "CCS1_500_A_REF" : "CCS2_500_A_REF"
  if (!v.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("REF")) {
    v.EV_TIPO_CONECTOR_RIGHT_FRONT = frontRef
  }
  if ((esDuo(v) || esCuatro(v)) && !v.EV_TIPO_CONECTOR_LEFT_FRONT.includes("REF")) {
    v.EV_TIPO_CONECTOR_LEFT_FRONT = frontRef
  }
  if (esCuatro(v) && !v.EV_TIPO_CONECTOR_LEFT_SIDE.includes("REF")) {
    v.EV_TIPO_CONECTOR_LEFT_SIDE = "NACS_500_A_REF"
  }
  if (esCuatro(v) && !v.EV_TIPO_CONECTOR_RIGHT_SIDE.includes("REF")) {
    v.EV_TIPO_CONECTOR_RIGHT_SIDE = "NACS_500_A_REF"
  }
}

const asignarLeftFrontDuo = v => {
  if (esDuo(v) && v.EV_TIPO_CONECTOR_LEFT_FRONT === "") {
    v.EV_TIPO_CONECTOR_LEFT_FRONT = v.EV_TIPO_CONECTOR_RIGHT_FRONT
  }
}

const configurarLateralesCuatro = v => {
  if (!esCuatro(v)) return
  if (v.EV_TIPO_CONECTOR_LEFT_SIDE === "") {
    v.EV_TIPO_CONECTOR_LEFT_SIDE = "NACS_380_A"
  }
  if (v.EV_TIPO_CONECTOR_LEFT_FRONT === "") {
    v.EV_TIPO_CONECTOR_LEFT_FRONT = v.EV_TIPO_CONECTOR_RIGHT_FRONT
  }
  if (v.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("REF")) {
    v.EV_TIPO_CONECTOR_RIGHT_SIDE = "NACS_500_A_REF"
  } else {
    v.EV_TIPO_CONECTOR_RIGHT_SIDE = "NACS_380_A"
  }
  if (
    v.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("REF") &&
    v.EV_TIPO_CONECTOR_LEFT_SIDE === "NACS_380_A"
  ) {
    v.EV_TIPO_CONECTOR_LEFT_SIDE = "NACS_500_A_REF"
  }
}

//Sincroniza el frontal izquierdo con el derecho cuando su refrigeración difiere
//(equivale a las dos reglas previas: RF-REF/LF-no-REF y viceversa) en DUO y DUO/4.
const sincronizarRefrigeracionFrontales = v => {
  if (!esDuo(v) && !esCuatro(v)) return
  const rfRef = v.EV_TIPO_CONECTOR_RIGHT_FRONT.includes("REF")
  const lfRef = v.EV_TIPO_CONECTOR_LEFT_FRONT.includes("REF")
  if (rfRef !== lfRef) {
    v.EV_TIPO_CONECTOR_LEFT_FRONT = v.EV_TIPO_CONECTOR_RIGHT_FRONT
  }
}

//#36: DUO/4 = 2xCCS1 (frontales) + 2xNACS (laterales). Ambos frontales van en CCS1
//(los laterales quedan en NACS). Solo varía la refrigeración (todas iguales).
const forzarFrontalesCuatroCcs1 = v => {
  if (!esCuatro(v)) return
  for (const posFrontal of [
    "EV_TIPO_CONECTOR_RIGHT_FRONT",
    "EV_TIPO_CONECTOR_LEFT_FRONT",
  ]) {
    const actual = v[posFrontal]
    if (actual.includes("NACS") || actual.includes("CCS2")) {
      v[posFrontal] = actual.includes("REF") ? "CCS1_500_A_REF" : "CCS1_380_A"
    }
  }
}

const aplicarMangueras = v => {
  if (v.EV_NUM_CONECTORES === "420_ONE" || esDuo(v)) {
    v.EV_LONGITUD_MANGUERA_SIDE = ""
  }
  if (esCuatro(v)) {
    v.EV_LONGITUD_MANGUERA_SIDE = "3_5M"
  }
}

export const rapid420 = newValues => {
  aplicarAcoplamientoPais(newValues)
  limpiarConectoresPorLayout(newValues)
  aplicarRefrigeracionAire(newValues)
  aplicarRefrigeracionLiquido(newValues)
  asignarLeftFrontDuo(newValues)
  configurarLateralesCuatro(newValues)
  sincronizarRefrigeracionFrontales(newValues)
  forzarFrontalesCuatroCcs1(newValues)
  aplicarMangueras(newValues)
  return newValues
}
